const $ = require('jquery/dist/jquery');

module.exports = {
    init: AjaxComponent,
    $ // for testing
};

function AjaxComponent(id) {
    const $container = $(`#${id}`);
    const settings = $container.data('settings');

    const { componentAjaxEndpoint, name, pageType, bussinessArea, args } = settings;

    // The ajax component object
    return {
        /**
         * Loads the specified component into the container
         */
        load() {
            return new Promise((resolve, reject) => {
                $container.addClass('loading');
                $.ajax({
                    type: 'POST',
                    url: componentAjaxEndpoint,
                    contentType: 'application/json',
                    data: JSON.stringify({
                        Name: name,
                        PageTypeName: pageType,
                        BusinessAreaName: bussinessArea,
                        Arguments: args
                    })
                })
                    .done(response => {
                        $container.html(response);
                        resolve(response);
                    })
                    .fail((jqXHR, errorText) => {
                        const error = errorText;
                        reject(error);
                    })
                    .always(() => {
                        $container.removeClass('loading');
                    });
            });
        }
    };
}
